import { useState } from "react";
import { useSelector } from "react-redux";
import { Segment, Select } from "semantic-ui-react";
import { AppState } from "../../../../../store/configureStore";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { AdditionalOutage } from "./CCValidationViews/AdditionalOutage";
import { NECSelectorCGM } from "./CCValidationViews/NECSelectorCGM";
import { NECSelectorCB } from "./CCValidationViews/NECSelectorCB";
import { ViewSavedOutages } from "./ViewSaved/ViewSavedOutages";
import { ViewSavedCriticalBranches } from "./ViewSaved/ViewSavedCriticalBranches";
import { ViewSavedBranches } from "./ViewSaved/ViewSavedBranches";
import { CCValidationRegionOptions } from "./CCValidationRegionOptions";
import { ccValidationModes } from "../../../../../models/nec";
import "./CCValidationRegion.css";

export const CCValidationRegion = () => {
    const [mode, setMode] = useState("additional-outage");
    const additionalOutages = useSelector((state: AppState) => state.additionalOutage.additionalOutages);
    const cgmBranches = useSelector((state: AppState) => state.cgmBranches.cgmBranches);
    const cbBranches = useSelector((state: AppState) => state.cbBranches.cbBranches);
    const hasManualElements = additionalOutages.length > 0 || cgmBranches.length > 0 || cbBranches.length > 0;

    return (
        <div id="div-cc-validation-container-a" className="cc-validation-container transition-container">
            <Segment id="cc-validation-segment-a" className="cc-validation-segment">
                <CCValidationRegionOptions />
                <div id="div-cc-validation-modes-wrapper-a" className="cc-validation-modes-wrapper">
                    <section id="section-cc-validation-region-a">
                        <h3 id="h3-cc-validation-region-additional-nec">Additional NEC or outage</h3>
                        <div id="div-cc-validation-region-input-a" className="cc-validation-input">
                            <p id="p-cc-validation-region-select-mode">Select mode</p>
                            <Select
                                id="select-cc-validation-region-a"
                                className="bottom-view-selector"
                                selectOnBlur={false}
                                options={ccValidationModes}
                                onChange={(e, data: any) => setMode(data.value)}
                                value={mode}
                            />
                        </div>
                    </section>
                    <section id="section-cc-validation-region-b" >
                        {hasManualElements && (
                            <p id="p-manual-elements-note" className="manual-elements-note">
                                Additional NECs and Outages will be considered only in the next calculation
                            </p>
                        )}
                        <ViewSavedOutages />
                        <ViewSavedCriticalBranches />
                        <ViewSavedBranches />
                    </section>
                </div>
                <div id="div-cc-validation-region-b" className="cc-validation-bottom">
                    <SwitchTransition mode="out-in">
                        <CSSTransition
                            id="CSSTransition-cc-validation-region-b"
                            key={mode}
                            addEndListener={(node, done) => {
                                node.addEventListener("transitionend", done, false);
                            }}
                            classNames="fade"
                            unmountOnExit
                        >
                            {(() => {
                                switch (mode) {
                                    case "additional-outage":
                                        return <AdditionalOutage />;
                                    case "nec-cb":
                                        return <NECSelectorCB />;
                                    case "nec-cgm":
                                        return <NECSelectorCGM />;
                                    default:
                                        return null;
                                }
                            })()}
                        </CSSTransition>
                    </SwitchTransition>
                </div>
            </Segment>
        </div>
    );
};
